<template>
  <div id="app">
    <!-- <div v-if="isDev" style="background: black; color: white; position: fixed; padding: 2px; left: 0; bottom: 0; right: 0; z-index: 200000; font-size: 8px;">DEV DETAILS: Window width: {{ this.$root.windowWidth/16 }} Window height: {{ this.$root.windowHeight/16 }}</div> -->
    <Nav :localpath="getlocalPath"></Nav>
    <div class="about">
      <header class="hero hero--local">
        <BgBox :opacity="getHeroOpacity" :src="getHeroImage" :invert="getHeroInvert" :alt="getHeroAlt">
          <div v-if="isReport" class="grid grid--header">
            <div class="intro">
              <h1 class="nocontent" v-html="_translate('report.intro.title')"></h1>
      				<div class="introContent">
                <p class="h2 subheading" v-html="_translate('report.intro.subheading')"></p>
                <p v-html="_translate('report.intro.content')"></p>
                <p v-html="_translate('report.intro.contentB')"></p>
              </div>
            </div>
            <div class="subtitle">
                <button @click="goto('insights')" class="jumplink">
                  {{ _translate('report.intro.year') }}
                  <Icon icon="ArrowDown"/>
                </button>
            </div>
            <div class="share">
              <span class="share__label">{{ _translate('report.intro.share') }}</span>
              <SocialShare platform="email"/>
              <SocialShare platform="facebook"/>
              <SocialShare platform="twitter"/>
              <SocialShare platform="linkedin"/>
            </div>
          </div>
          <div v-else-if="getSection() === 'local'" class="grid grid--header">
            <div class="intro">
              <h1>{{ _translate('local.intro.title') }}</h1>
              <p>{{ _translate('local.intro.content')}}</p>
            </div>
          </div>
          <div v-if="localNotice && getSection() === 'local'" class="notice">
            <p v-html="_translate('local.intro.notice')"></p>
          </div>
        </BgBox>
      </header>

      <router-view v-if="doLocal" @routed="onRouted" :key="'view' + $route.path"/>
      <Report v-else></Report>

    </div>
  </div>
</template>

<script>

  import Icon from '@/components/Icon.vue'
  import BgBox from '@/components/BgBox.vue'
  import Button from '@/components/Button.vue'
  import Nav from '@/components/Nav.vue'
  import SocialShare from '@/components/SocialShare.vue'

  import Report from '@/views/Report.vue'

  export default {

    metaInfo () {

      var title = this._translate(this.$route.meta['title']),
          description = this._translate(this.$route.meta['description']),
          url = location.origin + this.$route.path,

          section = 'local';

      var facebook_image = location.origin + '/img/social/' + section + '-share-2023-' + window.appLang + '.png?token=' + window.cacheToken,
          twitter_image = location.origin + '/img/social/' +  section + '-share-2023-' + window.appLang + '.png?token=' + window.cacheToken;

      return {

        title: title,
        bodyAttrs: {
          class: 'child-component'
        },
        meta: [
          { name: "dcterms.Identifier", content: "http://insights.realtor.ca" },
          { name: "dcterms.Format", content: "text/html" },
          { name: "dcterms.Relation", content: "CREA" },
          { name: "dcterms.Language", content: "en" },
          { name: "dcterms.Publisher", content: "CREA" },
          { name: "dcterms.Type", content: "text/html" },
          { name: "dcterms.Coverage", content: "http://insights.realtor.ca/" },
          { name: "dcterms.Rights", content: "Copyright &copy;2019 CREA." },
          { name: "dcterms.Title", content: title },
          { name: "dcterms.Creator", content: "CREA" },
          { name: "dcterms.Subject", content: "crea, real estate, canada, consumers, trends, houses, housing, realtors" },
          { name: "dcterms.Contributor", content: "CREA" },
          { name: "dcterms.Date", content: "2018-03-06" },
          { name: "dcterms.Description", content: description },

          // Facebook Open Graph

          { property: "og:type", content: "website" },
          { property: "og:locale", content: "en_ca" },
          { property: "og:url", content: url },
          { property: "og:title", content: title },
          { property: "og:description", content: description },
          { property: "og:image", content: facebook_image },
          { property: "og:image:type", content: "image/jpeg" },
          { property: "og:image:width", content: "1600" },
          { property: "og:image:height", content: "836" },
          { property: "og:site_name", content: "CREA" },
          { property: "og:see_also", content: "https://www.realtor.ca/" },
          { property: "og:see_also", content: "https://www.crea.ca/" },

          // Twitter Card

          { name: "twitter:card", content: "summary_large_image" },
          { name: "twitter:site", content: "@CREA_ACI" },
          { name: "twitter:title", content: title },
          { name: "twitter:description", content: description },
          { name: "twitter:image", content: twitter_image },

        ],
      }

    },

    data: function() {

      var localpath = this.$cookies.get('local' + window.ccode);

      return {
        localpath: (localpath) ? localpath : '/local',
      }

    },

    components: {
      Icon,
      BgBox,
      Button,
      Nav,
      SocialShare,

      Report,
    },

    watch: {

      '$route': {

        handler: function(to, from) {
          document.title = to.meta.title;
          this.$root.mobnav = false;
        },
        immediate: true,

      }

    },

    computed: {

      getHeroImage: function() {

        return (this.getSection() === 'report') ? 'header-2022' : 'header-2020-local';

      },

      getHeroOpacity: function() {

        return (this.getSection() === 'report') ? 0.3 : 0.3;

      },

      getHeroInvert: function() {

        return false;
        return (this.getSection() !== 'report')

      },

      getHeroAlt: function() {

        return (this.getSection() === 'report') ? this._translate('report.pagetitle.image.alt') : this._translate('local.footer.image.alt');

      },

      getlocalPath: function() {

        return this.$data.localpath;

      },

      // isReport: function() {

      //   return true;
      //   // return this.getSection() === 'report';

      // },

      isMobile: function() {

        var width = this.$data.windowWidth;
        return width < 768;

      },

      isTablet: function() {

        var width = this.$data.windowWidth;
        return width < 768;

      },

      isLaptop: function() {

        var width = this.$data.windowWidth;
        return width < 1024;

      },

    },

    methods: {

      onRouted: function (route) {
        this.$data.localpath = route;
      },

      // getWindowWidth(event) {
      //   this.windowWidth = document.documentElement.clientWidth;
      // },

      // getWindowHeight(event) {
      //   this.windowHeight = document.documentElement.clientHeight;
      // }

    },

    beforeDestroy: function() {
      window.removeEventListener('resize', this.getWindowWidth);
      window.removeEventListener('resize', this.getWindowHeight);
    }

  }
</script>

<style lang="scss">

  @import "@/sass/_normalize.scss";
  @import "@/sass/_boilerplate.scss";
  @import "@/sass/_typography.scss";
  @import "@/sass/_grid.scss";
  @import "@/sass/_transitions.scss";

  body {
    font-family: $font-family;
  }

  img {
    max-width: 100%;
    height: auto;
  }

  // General paragraph styles
  p {
    @include typesize('small');

    &.large {
      @include typesize('small');
      color: $grey-dark;
      @include mq('tab') {
        @include typesize('medium');
      }
    }

    &.huge {
      @include typesize('large');
      color: $grey-dark;
      @include mq('tab') {
        @include typesize('extra-large');
      }
    }

    &.truncate {
      max-width: 14rem;
      margin-left: auto;
      margin-right: auto;
    }

    &.emphasis {
      font-weight: 600;
    }

    .highlight {
      color: $blue;
    }

    &.disclaimer {
      font-size: 11px;
      line-height: 20px;
      color: $grey;
    }

  }

  // Basic styles for intro content
  .intro {

    max-width: 52rem;
    margin-bottom: 2rem;

    .subheading {
      font-weight: 600;
      color: $white;
    }

    p {
      font-weight: 300;
      max-width: 40rem;
    }

  }

  .intro--constrained {
    max-width: 30rem;
  }

  .introContent {

    max-width: 44rem;
    margin-bottom: 2rem;

  }

  // Styles for the hero-style banner.
  .hero {

    .bg-box {

      .wrapper {

        margin-top: calc(4rem + #{$nav-height * .7});
        margin-bottom: 2rem;

        @include mq('tab') {

          margin-top: calc(8rem + #{$nav-height});
          margin-bottom: 6rem;

        }

        @include mq('lap') {

          margin-top: calc(15rem + #{$nav-height});
          margin-bottom: 9rem;

        }

      }

    }

    h1 {
      margin-bottom: 0;
      margin-top: 0;
      position: relative;
      left: -.05em;

      &.nocontent {
        margin-bottom: 1rem;
      }
    }

    .intro p {
      color: $mist-darker;
      margin-top: 1em;

      &.subheading {
        color: $white;
      }
    }

    .subtitle {
      display: flex;
      flex-direction: row;
      white-space: nowrap;
      align-items: center;
      color: $mist-darker;
      font-weight: 300;

      hr {
        border-top: 1px solid $red;
        width: 100%;
        display: block;
        margin-left: 1rem;
        position: relative;
        top: 1px;
      }

    }

    .share {

      justify-content: center;
      margin-top: 2.75rem;

      @include mq('tab') {
        margin-top: 0;
        justify-content: flex-end;
      }

    }

  }

  .share {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;

    @include mq('tab') {
      flex-wrap: nowrap;
    }

    .social-share {
      margin-left: 1rem;
    }

  }

  .share__label {
    text-transform: uppercase;
    letter-spacing: .15em;
    display: block;
    width: 100%;
    text-align: center;
    margin-bottom: 1rem;

    @include mq('tab') {
      display: inline;
      width: auto;
      margin-bottom: 0;
    }
  }

  .module__body {

    .wrapper {

      width: 100%;
      max-width: $wrapper;
      // margin: 2rem .75rem 0;
      transition: margin .3s ease;

      // @include mq('tab') {
      //   margin: 4rem 1.5rem;
      // }

      // @include mq('lap') {
      //   margin: 6rem 1.5rem;
      // }

    }

    .wrapper--legal {

      @include mq('tab') {
        margin: 4rem 1.5rem;
      }

      @include mq('lap') {
        margin: 6rem 1.5rem;
      }

    }    

    .container {
      position: relative;
      z-index: 1;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    section {

      margin-bottom: 3rem;

      p {

        font-weight: 300;

        &.large,
        &.huge,
        &.emphasis {
          font-weight: 600;
        }

      }

      @include mq('lap') {

        margin-bottom: 6rem;

      }

    }

  }

  .section-btn {
    display: flex;
    justify-content: center;
    margin: .5rem 0 4.5rem;
  }

  .notice {
    background: $blue-dark;
    margin-top: 3rem;
    margin-bottom: -3rem;
    padding: 2rem;
    text-align: center;
  }

  .jumplink {
    appearance: none;
    color: $white;
    text-decoration: none;
    font-weight: 500;
    font-size: 18px;
    background-color: transparent;
    border: 2px solid $red;
    border-radius: 22px;
    padding: .625rem 1.5rem;
    transition: background-color .2s ease-out;
    cursor: pointer;


    &:hover,
    &:focus {
      background-color: $red;
    }

    .icon {
      display: inline;
    }

    svg {
      fill: $red;
      margin-left: .5rem;
      transition: fill .2s ease-out;
    }

    &:hover svg,
    &:focus svg {
      fill: $white;
    }
  }

</style>
